<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/YUJYHS/tc-custom/9781952871207.jpg?1726574202247" alt="This image is the cover for the book 50 Days of Pleasure, Days of Pleasure Series"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">50 Days of Pleasure, Days of Pleasure Series
      </h1>
      <p class="bookDescription body article font2">
        <b>When an obsessive fan threatens to derail Basketball Superstar Dallas Avery’s relationship with the alluring and independent Alicia Mitchell, a trip to Canada comes at the opportune time. The historic sites and chilly landscapes help to stir the growing connection between the couple.</b><br/><br/>Then a distressed infant is thrust into their care. The teenage mother and her baby are in danger and only trust Dallas and Alicia to help. With the local mob in pursuit and Dallas and Alicia unable to depend on the police, they must flee the country using a historic mode of escape.<br/><br/><b>ABOUT THE DAYS OF PLEASURE SERIES</b><br/>Each Pleasures book is a standalone, NO cliffhangers<br/><br/>USA TODAY, and National Bestselling Authors take you on amazing journey with NBA Basketball Star, Dallas Avery, and Alicia Mitchell, a woman who is as mysterious as she is beautiful.<br/>Follow this unlikely couple as they travel to exotic places such as Paris, Durabia, Caribbean, Scotland and many others. Each story embroils them in a new set of challenges and adventure as they navigate their way to love.<br/><br/>Book 1–10 Days of Pleasure by Stephanie M. Freeman<br/>Book 2–20 Days of Pleasure by J. L. Campbell<br/>Book 3–30 Days of Pleasure by Sierra Kay<br/>Book 4–40 Days of Pleasure by Martha Kennerson and Stephanie M. Freeman<br/>Book 5–50 Days of Pleasure by Anita L. Roseboro and Michelle D. Rayford<br/>Book 6–60 Days of Pleasure by Vanessa<br/>Book 7–70 Days of Pleasure by Christine Pauls<br/>Book 8–80 Days of Pleasure by Aiken Ponder<br/>Book 9–90 Days of Pleasure by Marie L. McKenzie and Naleighna Kai<br/>Book 10—Open Door Marriage by Naleighna Kai
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Anita L. Roseboro, Michelle D. Rayford,
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Macro Publishing Group
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?60fa4538